import { MutationTree } from 'vuex'
import { UserState, User } from '@/types/User'
import Vote from '@/types/Vote'
import Vue from 'vue'

export const mutations: MutationTree<UserState> = {
  setUser (state, payload: User) {
    state.user = payload
  },
  setDisplayName (state, payload: string) {
    if (state.user) state.user.displayName = payload
  },
  setTokenExpires (state, payload: number) {
    state.tokenExpires = payload
  },
  setPrivateToken (state, payload: string) {
    state.privateToken = payload
  },
  setHasAuthorizedSpotify (state, payload: boolean) {
    state.hasAuthorizedSpotify = payload
  },
  setRefreshToken (state, payload: string) {
    state.refreshToken = payload
  },
  addSongVotedFor (state, payload: Vote) {
    Vue.set(state.songsVotedFor, payload.requestID, payload)
  },
  removeSongVotedFor (state, payload: Vote) {
    Vue.delete(state.songsVotedFor, payload.requestID)
  },
  clearSongsVotedFor (state) {
    state.songsVotedFor = []
  }
}
